import { ErrorHandler, Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ErrorNotificationService implements ErrorHandler {

    handleError(error: any) {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (chunkFailedMessage.test(error.message)) {
            // alert("This is an outdated version of this webpage. This page will now be refreshed.")
          window.location.reload();
        }
    }
}